module.exports = __webpack_public_path__ + "img/bg_main07_mask.d44f5574.svg";